import React from 'react';
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Layoutcreatepage from "../../../components/common/Form/Create-Layout";
import { useUpdateFoodItemMutation ,useDeleteFoodItemMutation} from '../../../store/api/meals';

function EditFoodItem() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [updateFood] = useUpdateFoodItemMutation(); 
    const [initialValues, setInitialValues] = useState({
        name: "",
        calories: "",
        protein: "",
        carbs: "",
        fats: "",
    });
    

    const [feedbackMessage, setFeedbackMessage] = useState({ 
        type: "",
        message: "",
    });
    const fields = [
 
        {
            name: "calories",
            label: "Calories",
            type: "number",
            placeholder: "Enter calories",
            required:true
          },
          {
            name: "protein",
            label: "Protein",
            type: "number",
            placeholder: "Enter protein",
            required:true
          },
          {
            name: "name",
            label: "Fooditem",
            type: "text",
            placeholder: "Enter Food Item Name",
            required:true
          },
          {
            name: "carbs",
            label: "carbs",
            type: "number",
            placeholder: "Enter carbs",
            required:true
          },
          {
            name: "fats",
            label: "Fats",
            type: "number",
            placeholder: "Enter Fats",
            required:true
          },
      ];
    const EditFood = location?.state?.data;    
    useEffect(() => {
        if (EditFood)  {
            setInitialValues({
                name: EditFood.name,
                calories: EditFood.calories,
                protein: EditFood.protein,
                carbs: EditFood.carbs,
                fats: EditFood.fats,
            });
            setLoading(false)
        }
    }, [EditFood]);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        calories: Yup.number().required("Calories are required"),
        protein: Yup.number().required("Protein is required"),
        carbs: Yup.number().required("Carbs are required"),
        fats: Yup.number().required("Fats are required"),
    });

    const handleCancel = () => {
        navigate("/mealitem-list" ,{ state: { pageName: "Food Item" } });
      };
    
    

    const onSubmit =async(values)=>{

        const payload = {
            name :values.name,
            calories:values.calories,
            protein:values.protein,
            carbs:values.carbs,
            fats:values.fats
        }
        
        
        const response = await updateFood({data:payload,id:EditFood.id})
       
        if(response.error){
            setFeedbackMessage({
              type: "error",
              message: response?.error?.data?.error,
              });
          }else{
            if (response.data) {
              setFeedbackMessage({
                type: "success",
                message: "Fooditem updated successfully!",
              });
              
              setTimeout(() => {
                navigate("/mealitem-list" ,{ state: { pageName: "Food Item" }});
              }, 2000);
            } 
          }
    
    }

    
    return (
        <div className='pb-4 pt-3'>
             {loading == false ? 
             <Layoutcreatepage
                      title="Edit FoodItem"
                      fields={fields}
                      validationSchema={validationSchema}
                      initialValues={initialValues}
                      onSubmit={onSubmit}
                      buttonText="Update FoodItem"
                      navigateTo="/mealitem-list"
                      loading={loading}
                      feedbackMessage={feedbackMessage}
                      onCancel={handleCancel}
                    />:  ''}
        </div>
    );
}

export default EditFoodItem;